import { JOBS_RETRIED_EVENT } from "../../types/events/jobsRetried.js";
import { request as utilsRequest } from "../../utils/request.js";
import { locationRestJobsSkipPost } from "../../wp-api/jobsSkip.post.js";
import { fetchStatus } from "../fetchStatus.js";
/**
 * Skip jobs by e.g. type.
 */ async function skipJobs(request) {
    const response = await utilsRequest({
        location: locationRestJobsSkipPost,
        request
    });
    document.dispatchEvent(new CustomEvent(JOBS_RETRIED_EVENT, {
        detail: {
            request,
            response
        }
    }));
    await fetchStatus(true);
}
export { skipJobs };
